// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__5BsJN","name":"ConsentHeader_name__3tuw6","birthday":"ConsentHeader_birthday__2qM1i","skeleton":"ConsentHeader_skeleton__26WtM"};